import OktaService from '../../services/OktaService';

class Auth {
  constructor() {
    this.authenticated = false;
  }

  login(cb) {
    this.authenticated = true;
    cb();
  }

  /**
   * Sign out via Okta end-session redirect.
   * Do not clear Okta tokens first — logout needs the idToken as id_token_hint.
   */
  logout(cb) {
    this.authenticated = false;
    if (typeof cb === 'function') cb();
    return OktaService.logout();
  }

  /** Clear local auth state only (e.g. before redirecting to Okta logout). */
  clearLocalSession() {
    this.authenticated = false;
    OktaService.clearLocalTokens();
  }

  isAuthenticated() {
    return this.authenticated;
  }
}

const authInstance = new Auth();
export default authInstance;
